import React from 'react';
import { useTranslation } from 'react-i18next';

interface InformationCardContentValueLabelProps {
  cardValue: { value?: any; unit?: string };
  description: string;
  id: string;
}

const InformationCardContentValueLabel: React.FC<InformationCardContentValueLabelProps> = ({ cardValue, description, id }) => {
  const { t } = useTranslation();
  return (
    <div>
      <span key={`${id}-value-label`} className="paragraph">
        <span className="heading5">
          {(cardValue?.value || '-.- ') + (cardValue?.unit || '')}
        </span>
      </span>
      <span key={`${id}-value-label-description`} className="paragraph">
        {t(description)}
      </span>
    </div>
  );
};

export default InformationCardContentValueLabel; 